import React from 'react'
import {_AccordionButton} from "./_AccordionButton";
import Accordion from "react-bootstrap/Accordion";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import {useSelector} from "react-redux";
import {Loading} from "../../../ui/loading/Loading";
import {zynity_api} from "../../../../config/external-routes";
import {_Comments} from "./_Comments";
import {_SubDatum} from "./_SubDatum";
import {isDatumDraft} from "../../../../helpers/cnaDraft";
import {normalizeDatumLinks, normalizeDatumUploads} from "../../../../helpers/cnaAttachments";
import {ZyniItemInsight} from "../../../engagement/item_insight/ZyniItemInsight";

export const DatumAccordionItem = ({datum, total_coach_notes, handleEditItem, handleDeleteItem, handleAddComment, handleEditComment, clickRemoveComment, handleChangeListOrder, handleOpenReminder, isSubItem, clickNewItem, readOnly, subdatumModalOpenKey, handleArchiveItem, handleActiveItem, handleMarkPrivateItem, handleMarKNotificationsAsRead, clickMoveItem, selectedMember, handleSelectItem}:any) => {
    const team_obj = useSelector((state: any) => state.organization_team);
    const authenticated_user = useSelector((state: any) => state.auth);
    const a = moment();
    const b = moment(datum.dateCreated);
    const days = a.diff(b, 'days')

    if(team_obj.isLoading === true) {
        return <Loading />;
    }

    const getAuthorKnowAs = (people_id: number) => {
        let author = team_obj?.data?.members?.find((member: { id: number; }) => (member.id === people_id))
        if(author === undefined) {
            return 'Not Found';
        }

        return author.KnownAs;
    }

    const getAuthorInitials = (people_id: number) => {
        let author = team_obj?.data?.members?.find((member: { id: number; }) => (member.id === people_id))
        if(author === undefined) {
            author = team_obj?.data?.viewers?.find((member: { id: number; }) => (member.id === people_id))
            if(author === undefined) {
                return '--';
            }
        }

        return `${author.FirstName.substring(0, 1)}${author.LastName.substring(0, 1)}`;
    }

    // Use backend flag as source of truth:
    // 1) Prefer `is_broadcast`
    // 2) Fallback to aliases only when canonical field is absent.
    const hasCanonicalBroadcastFlag = Object.prototype.hasOwnProperty.call(datum ?? {}, 'is_broadcast');
    const isBroadcastMessage = datum?.type1 == 'Message' && (
        hasCanonicalBroadcastFlag
            ? datum?.is_broadcast === true
            : (datum?.isBroadcast === true || datum?.is_broadcast_message === true)
    );

    let color = '#FFFADE'
    if(datum.isPrivate == 'Private') {
        color = '#c5c5c5'
    } else if (isBroadcastMessage) {
        color = '#F2F8FF'
    }
    const isDraft = isDatumDraft(datum);
    const normalizedLinks = normalizeDatumLinks(datum?.links, datum?.documents);
    const normalizedUploads = normalizeDatumUploads(datum?.uploads, datum?.documents);

    let is_author = false;
    if(selectedMember != undefined && datum.type1 == 'Message' && datum.idAuthor == authenticated_user.id) {
        is_author = true;
    }

    return (
        <Accordion.Item
            eventKey={datum.id.toString()}
            style={{
                backgroundColor: color,
                color: 'black',
                border: isDraft ? '2px solid teal' : '1px solid #9b9b9b',
                borderTop: isDraft ? '2px solid teal' : '1px solid #9b9b9b'
            }}
        >
            <_AccordionButton eventKey={datum.id.toString()} 
            coach_note={datum} total_coach_notes={total_coach_notes}
            handleEditItem={handleEditItem} handleDeleteItem={handleDeleteItem}
            handleAddComment={handleAddComment} handleChangeListOrder={handleChangeListOrder}
            handleArchiveItem={handleArchiveItem}
            handleMarkPrivateItem={handleMarkPrivateItem}
            handleSelectItem={handleSelectItem}
            handleMarKNotificationsAsRead={handleMarKNotificationsAsRead}
            handleActiveItem={handleActiveItem}
            clickNewItem={clickNewItem}
            clickMoveItem={clickMoveItem}
            isBroadcastMessage={isBroadcastMessage}
            readOnly={readOnly}
            is_author={is_author}
            isSubItem={isSubItem}
            handleOpenReminder={handleOpenReminder}>{datum.title}</_AccordionButton>
            <Accordion.Body style={{backgroundColor: 'white'}}>
                <div className="row">
                    {/* Story */}
                    <div className="col-12 datum-description-content" dangerouslySetInnerHTML={{__html: datum.description}}/>

                    <div className="col-12 mt-1 mb-1 p-1" style={{backgroundColor: '#F1F1F1'}}>
                        {
                            datum.type1 == 'Message' &&
                            <div className="rounded-circle" style={{backgroundColor: 'teal', padding: '5px', color: 'white', display: 'inline-block', textAlign: 'center', fontSize: '10px', fontFamily: 'sans-serif'}}>
                                {getAuthorInitials(datum.idAuthor)}
                            </div>
                        }
                        <span className='mx-2'><span className='text-muted'>Created: </span>{moment(datum.dateCreated).format('DD MMM YYYY')}</span>
                        <span className='mx-3'><span className='text-muted'>Last Edit: </span>{moment(datum.lastModified).format('DD MMM YYYY')}</span>
                        <span className='mx-3'><span className='text-muted'>Open: </span>+{days} days</span>
                    </div>

                    {
                        datum.type1 == 'Deliverable' && isSubItem === false && !isDraft &&
                        <div className="col-12 p-0">
                            <ZyniItemInsight
                                organizationId={team_obj?.data?.idOrganization}
                                teamId={team_obj?.data?.id}
                                datumId={datum.id}
                            />
                        </div>
                    }

                    {/* Display here the event */}
                    {
                        datum?.event_start && datum?.event_end &&
                        <>
                            <div className="col-1 col-lg-1 p-0 border-right mt-1">Event:</div>
                            <div className="col-10 col-lg-11 mt-1">
                                <div className="mb-2" style={{paddingLeft: '15px'}}>
                                    {/* Start and End on the same line */}
                                    <div>
                                        <span className="text-muted">Start: </span>
                                        {datum.is_all_day ? (
                                            <>
                                                {moment(datum.event_start).format('MMM D, YYYY')} (All Day)
                                            </>
                                        ) : (
                                            <>
                                                {moment(datum.event_start).format('MMM D, YYYY, h:mm A')} &nbsp;
                                                <span style={{ whiteSpace: 'nowrap' }}>
                                                    <span className="text-muted">End: </span>
                                                    {moment(datum.event_end).format('MMM D, YYYY, h:mm A')}
                                                </span>
                                            </>
                                        )}
                                    </div>

                                    {/* Location on new line (if exists) */}
                                    {datum.event_location && (
                                        <div>
                                            <span className="text-muted">Location: </span>
                                            {datum.event_location}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <hr className='mt-2' style={{border: 0, borderTop: '1px solid #d1d1d1'}}/>
                        </>
                    }

                    {
                        normalizedLinks.length > 0 &&
                        <>
                            <div className="col-1 col-md-1 col-lg-1 p-0 border-right mt-1">Links:</div>
                            <div className="col-10 col-lg-11 mt-1">
                                <div style={{paddingLeft: '15px'}}>
                                {
                                    normalizedLinks.map((link) => (
                                        <div>
                                            <a className='color-teal breakable-link' href={link.href} target='_blank' rel='noreferrer' title={link.href}>{link.label}</a>
                                        </div>
                                    ))
                                }
                                </div>
                            </div>

                            <hr className='mt-2' style={{border: 0, borderTop: '1px solid #d1d1d1'}}/>
                        </>
                    }

                    {
                        normalizedUploads.length > 0 &&
                        <>
                            <div className="col-3 col-md-2 col-lg-1 p-0 border-right mt-1">Uploads</div>
                            <div className="col-9 col-md-10 col-lg-11 mt-1">
                                {
                                    normalizedUploads.map((upload) => (
                                        <div><a className='color-teal' href={`${zynity_api.global_download_files}?path=${upload.fileName}&force_download=true&custom_name=${upload.displayName}`}>{upload.displayName}</a></div>
                                    ))
                                }
                            </div>

                            <hr className='mt-2' style={{border: 0, borderTop: '1px solid #d1d1d1'}}/>
                        </>
                    }

                    <_Comments datum={datum} handleAddComment={handleAddComment} handleEditComment={handleEditComment} clickRemoveComment={clickRemoveComment} />

                    {
                        isSubItem === false && datum.type1 != 'Message' &&
                        <_SubDatum
                            datum={datum}
                            clickEditItem={handleEditItem}
                            clickAddComment={handleAddComment}
                            handleChangeListOrder={handleChangeListOrder}
                            handleOpenReminder={handleOpenReminder}
                            handleMarkPrivateItem={handleMarkPrivateItem}
                            clickEditComment={handleEditComment}
                            clickRemoveComment={clickRemoveComment}
                            clickDeleteItem={handleDeleteItem}
                            clickNewItem={clickNewItem}
                            handleArchiveItem={handleArchiveItem}
                            handleActiveItem={handleActiveItem}
                            handleMarKNotificationsAsRead={handleMarKNotificationsAsRead}
                            readOnly={readOnly}
                            subdatumModalOpenKey={subdatumModalOpenKey}
                            handleSelectItem={handleSelectItem}
                        />
                    }

                </div>
            </Accordion.Body>
        </Accordion.Item>
    )
}
